export type MessagingLimitView = {
  readonly state: string;
  readonly maxUniqueRecipients?: number | 'unlimited' | null;
};

export function formatLimit(limit: MessagingLimitView): string {
  if (limit.state === 'reported') {
    return limit.maxUniqueRecipients === 'unlimited'
      ? 'Sem limite informado em quantidade'
      : typeof limit.maxUniqueRecipients === 'number'
        ? limit.maxUniqueRecipients.toLocaleString('pt-BR')
        : 'Não informado pela Meta';
  }
  return 'Não informado pela Meta';
}
